import React, { Component } from "react";
import TextField from "./../../Components/common/TextFieldLg";
import Button from "./../../Components/common/Button";
import Loader from "./../../Layout/Loader";
import { logInUserInfo, getRoles } from "./../../Actions/Users";
import { ServerInfo } from "./../../Actions/serverSetting";
import { getLayer } from "./../../Actions/Maps";
import { Trans as Translate} from 'react-i18next';
import { fetchDevicesList, fetchDevices } from "./../../Actions/Devices";
import {
  displayErrorMessages,
  checkedDevelopmentType,
  errorHandler,
  checkPrivileges,
  getCompanyById,
} from "../../Helpers/index";
import Checkbox from "../../Components/common/Checkbox";
import SocketController from "../../SocketController";
import { connect } from "react-redux";
import Style from "style-it";

import { NavLink } from "react-router-dom";
import InfoIcon from "./../../assets/monitoring/info.svg";
import { themes } from "../../Reducers/Theme";
import instance from "../../axios";
import {notifySuccess } from "../../Utils/CustomNotifcations";
import withTranslationWrapper from "../../HOC/withTranslation";
import { CircularProgress, Typography } from "@mui/material";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';



const mapState = (state) => {
  return {
    themecolors: themes[2],
    devices: state.devices.data,
    ServerSetting: state.ServerSetting,
    logInUser: state.logInUsers,
  };
};

class LoginWithPhone1 extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, loginErrorMessage: "" };
    this.handleChange = this.handleChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state !== ""
    ) {
      this.setState({
        failed: true,
        loginErrorMessage: this.props.location.state,
      });
    }
    this.setState({
      email: this.getCookie("userName"),
      password: this.getCookie("pass"),
    });
  }
  handleChange(event) {
    this.setState({
      [event.target.id]: event.target.value,
    });
  }
  getDueDeliveryNotesCounts = () => {
    let today = new Date();
    let fourDaysAgo = new Date();
  
    fourDaysAgo.setDate(today.getDate() - 7);
    fourDaysAgo.setHours(0, 0, 0, 0);
    today.setHours(23, 59, 59, 999);
  
    let fromDate = `from=${fourDaysAgo.toISOString()}`;
    let toDate = `to=${today.toISOString()}`;
  
    instance({
      url: `/api/deliverynotes/getdnsmorethanone?${fromDate}&${toDate}`,
      method: "GET",
    })
      .then((response) => {
        const flattenedArray = Object.values(response)?.flat();
        if(flattenedArray.length>0){
          localStorage.setItem('isDubiousDeliveryShow', 'true');
        }
        const updatedUserInfo = {
          ...this.props.logInUser,
          dueDeliveryNoteCount:flattenedArray?.length,
        };
        this.props.dispatch(logInUserInfo(updatedUserInfo));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  
getWaitingForCustomerApprovalServices = () => {
  const today = new Date();
  const fourDaysAgo = new Date();
  fourDaysAgo.setDate(today.getDate() - 3);
  fourDaysAgo.setHours(0, 0, 0, 0);
  today.setHours(23, 59, 59, 999);
  const fromDate = `from=${fourDaysAgo.toISOString()}`;
  const toDate = `to=${today.toISOString()}`;
  const url = `/api/services/get?page=1&limit=20&${fromDate}&${toDate}` +
              `&status=GarageToCustomer&status=OpToCustomer`;
  instance({
    url,
    method: "GET",
  })
    .then((response) => {
const count = Array.isArray(response?.data) ? response.data.length : 0;
localStorage.setItem("waitingCustomerCount", count.toString());

if (count > 0) {
  localStorage.setItem("showModalForCustomer", "true");
} else {
  localStorage.removeItem("showModalForCustomer");
}
    })
    .catch((error) => {
        localStorage.removeItem("waitingCustomerCount");
        localStorage.removeItem("showModalForCustomer");
      console.error("Error:", error);
    });
};

  handleLogin(event) {
    
    event.preventDefault();
    const { otp, phone } = this.props;
    this.setState({
      failed: false,
      loading: true,
      loginErrorMessage: "",
    });
    let fetchUrl = checkedDevelopmentType();
    instance({
      url: `/api/session`,
      method: "POST",
      data: new URLSearchParams({
        otp: otp,
        phone: phone,
        app: `3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05`,
        // host: fetchUrl,
      }),
    })
      // .then(response => {
      //   if (response.ok) {
      //     response.json()
      .then((userInfoFront) => {
        // fetch call for Api  privileges
        let lang = userInfoFront.attributes.lang;
        this.props.setActiveLanguage(lang || "en");
    localStorage.setItem('isPaymentDueShown', 'true');
        // notifyError("attributeDevicePassword")

        /* fetch(
              `/api/devices/list?userId=${userInfoFront.id}&all=true&limit=-1`
            ).then(response => {
              if (response.ok) {
                response.json().then(devices => {
                  this.props.dispatch(getDevices2(devices.data))
                })
              }
            })
            fetch(
              `/api/devices/get?userId=${userInfoFront.id}&all=true&page=1&limit=-1`
            ).then(response => {
              if (response.ok) {
                response.json().then(res => {
                  this.props.dispatch(getDevices(res.data))
                  this.props.dispatch(getDevices3(res.data))
                })
              }
            }) */

        // fetch(`/api/privileges?roleId=${userInfoFront.roleId}`, {
        //   method: 'Get'
        // })
        instance({
          url: `/api/privileges`,
          method: "GET",
          params: {
            roleId: userInfoFront.roleId,
          },
        })
          // .then(response => {
          //   if (response.ok) {
          //     response.json()
          .then((privileges) => {
            let privilegeKeys = [];
            privileges.map((item) => {
              privilegeKeys.push(item.key);
              return null;
            });
            localStorage.setItem(
              "frontPrivileges",
              JSON.stringify({ ...privilegeKeys })
            );
            if (privileges.length) {
              this.getDueDeliveryNotesCounts()
              this.getWaitingForCustomerApprovalServices()
              this.props.dispatch(logInUserInfo(userInfoFront));
              checkPrivileges("device") &&
                this.props.dispatch(fetchDevicesList(userInfoFront));
              checkPrivileges("device") &&
                this.props.dispatch(fetchDevices(userInfoFront));

              if (userInfoFront.userType === -1) {
                // fetch(`/api/roles?all=true`)
                instance({
                  url: `/api/roles`,
                  method: "GET",
                  params: {
                    all: true,
                  },
                })
                  // .then(response => {
                  //   if (response.ok) {
                  //     response.json()
                  .then((role) => {
                    this.props.dispatch(getRoles(role));
                    //   })
                    // }
                    // else{
                    //   throw response
                    // }
                  })
                  .catch((error) => {
                    // errorHandler(error, this.props.dispatch)
                  });
              } else if (
                userInfoFront.userType !== 1 &&
                checkPrivileges("role")
              ) {
                // fetch(`/api/roles?userId=${userInfoFront.id}`)
                instance({
                  url: `/api/roles`,
                  method: "GET",
                  params: {
                    userId: userInfoFront.id,
                  },
                })
                  // .then(response => {
                  //     if (response.ok) {
                  //       response.json()
                  .then((role) => {
                    this.props.dispatch(getRoles(role));
                    //   })
                    // }
                    // else{
                    //   throw response
                    // }
                  })
                  .catch((error) => {
                    // errorHandler(error, this.props.dispatch)
                  });
              }

              // fetch(`/api/accounts?accountId=${userInfoFront.accountId}`)
              instance({
                url: `/api/accounts`,
                method: "GET",
                params: {
                  accountId: userInfoFront.accountId,
                },
              })
                // .then(response => {
                //   if (response.ok) {
                //     response.json()
                .then((server) => {
                  if (server[0]) {
                    //implatation of whitelabeling to replace data
                    this.props.dispatch(ServerInfo(server[0]));
                                                 getCompanyById(server[0]?.companyId)
                                                .then((company) => {
                                                                                localStorage.setItem(
                      'userInfo',
                      JSON.stringify({
                        ...(JSON.parse(localStorage.getItem('userInfo')) || {}),
                        companyId: server[0].companyId,
                      })
                    );
                                                  // this.props.dispatch(setCompanyy(company))
                                                }).catch((error) => {
                                                  console.error(error.message)
                                                });
                    this.props.dispatch(
                      getLayer({
                        id:
                          userInfoFront.map ||
                          (server && server[0].map) ||
                          "osm",
                      })
                    );
                    // console.log("this.props.location.state=====", this.props.location.state);
                    if(userInfoFront.customerType === 1 || userInfoFront.customerType === 2){
                      this.props.history.push("/maintenance");
                    }else{
                    if (this.props.location && this.props.location.state) {
                      this.props.history.push(this.props.location.state);
                    } else {
                      this.props.history.push("/maintenance");
                    }
                  }

                  } else {
                    this.someThingWendWrong("Account Data Not Found");
                  }
                })
                //   } else {
                //     throw response
                //   }
                // })
                .catch((error) => {
                  // errorHandler(error, this.props.dispatch, this.errorCallBack)
                  this.setState({
                    failed: true,
                    password: "",
                    loading: false,
                    loginErrorMessage: displayErrorMessages(error.message),
                  });
                });
            } else {
              this.setState({
                failed: true,
                password: "",
                loading: false,
                loginErrorMessage: "Lack Of Privileges",
              });
            }
          })
          //   } else {
          //     throw response
          //   }
          // })
          .catch((error) => {
            // errorHandler(error, this.props.dispatch, this.errorCallBack)
            this.setState({
              failed: true,
              password: "",
              loading: false,
              loginErrorMessage: displayErrorMessages(error.message),
            });
          });
        //   })
        // } else {
        //   throw response
        // }
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch, this.errorCallBack);
      });
  }
  // errorMessage = e => {
  // if (e && e.text) {
  //   e.text().then(err => {
  //     console.log("login failed ==", err)
  //     this.setState({
  //       failed: true,
  //       password: '',
  //       loading: false,
  //       loginErrorMessage: displayErrorMessages(err)
  //     })
  //   })
  // }
  // }

  handleClick = (e) => {
    let { email, password } = this.state;
    if (e.target.checked && email && password) {
      this.setCookie("userName", email);
      this.setCookie("pass", password);
    } else {
      this.setCookie("userName", "");
      this.setCookie("pass", "");
    }
  };
  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  setCookie(name, value, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie =
      name + "= " + encodeURIComponent(value) + ";" + expires + ";path=/login;";
  }
  someThingWendWrong = (mgs) => {
    this.setState({
      failed: true,
      password: "",
      loading: false,
      loginErrorMessage: this.props.translate(mgs),
    });
  };
  render() {
      const {
      phone,
      otp,
      isPhoneValid,
      isOTPSent,
      isOTPValid,
      failed,
      loading,
      resendTimer,
      showResendButton,
      loginErrorMessage,
    } = this.props;

      return (
        <form
        //   className="loginForm"
          onSubmit={this.props.handleSend}
          autoComplete="off"
          style={{marginTop:'4rem'}}
        >
          {/* <div className='login-logo-wrapper'>
            <img
              className='login-logo'
              src={this.props.whiteLabling.logo}
              alt='logo'
            />
          </div> */}
          {/* <h1
            className="alt-title text-center"
            style={{ marginBottom: 25, marginTop: 25, fontSize: 38 }}
          >
            <Translate i18nKey="loginTitle" />
          </h1> */}
    
          {failed && (
            <div
              className="alert alert-danger"
              style={{
                color: this.props.themecolors["error"],
              }}
            >
              <svg fill="currentColor" width={16} height={16}>
                <use xlinkHref={`${InfoIcon}#icon`} />
              </svg>
              {this.props.translate(loginErrorMessage)}
            </div>
          )}
        {!isOTPSent&&
        <>
                <PhoneInput
          country={'sa'}
          value={phone}
          onChange={this.props.handlePhoneChange}
          inputStyle={{ width: '100%' }}
          containerStyle={{ marginBottom: 16 }}
        />

  <p style={{ textAlign: "center", marginBottom: 10 }}>
            <Button
              themecolors={this.props.themecolors}
              type="submit"
              className="btn-submit theme-green"
                  disabled={!isPhoneValid||loading || this.state.loading} // disable when loading
    startIcon={
      (this.state.loading||loading) && (
        <CircularProgress size={20} color="inherit" />
      )
    }
            >
              {this.props.translate("loginLogin")}
            </Button>
          </p>

        </>
        }
  
     {isOTPSent && (
  <>
    <TextField
      label={this.props.translate('enter4OTP')}
      value={otp}
      onChange={this.props.handleOTPChange}
      fullWidth
      inputProps={{ maxLength: 4 }}
      margin='normal'
    />

    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
      <Button
        variant='contained'
        color='primary'
        disabled={!isOTPValid||this.state.loading}
        onClick={this.handleLogin}
      >
         {this.state.loading
      ? this.props.translate('loading') || 'Sending...'
      : this.props.translate('verifyOTP')}
      </Button>
    </div>

    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
      {!showResendButton ? (
        <Typography variant='body2' color='textSecondary'>
          {this.props.translate("Resend OTP in")} {String(Math.floor(resendTimer / 60)).padStart(2, '0')}:
          {String(resendTimer % 60).padStart(2, '0')}
        </Typography>
      ) : (
        <Button variant='text' onClick={this.props.handleResend} disabled={this.state.loading||loading}>
          {this.props.translate("Resend OTP")}
          
        </Button>
      )}
    </div>
  </>
)}


          {this.props.logInUser && this.props.logInUser.id ? (
            <SocketController />
          ) : null}
        </form>
      );
    }
  }
// }

const mapStateToProps = connect(mapState);

export const LoginWithPhone= mapStateToProps(withTranslationWrapper(LoginWithPhone1));